import React from 'react';
import PropTypes from 'prop-types';
import RelinkUpdateBlock from './RelinkUpdateBlock';

const ApkUpdate = props => (
    <RelinkUpdateBlock
        {...props}
        title="Обновление APK"
        idPrefix="apk"
        versionField="apk_version"
        versionUpdatedField="apk_version_updated"
        fileLabel="Файл APK"
        fileMetaField="fileName"
    />
);

ApkUpdate.propTypes = {
    permissions: PropTypes.string,
    station: PropTypes.object,
    canAccessFirmware: PropTypes.func,
    getApkVersion: PropTypes.func,
    loadApkFiles: PropTypes.func,
    updateApk: PropTypes.func,
};

export default function ApkUpdateWrapper({
    canAccessFirmware,
    getApkVersion,
    loadApkFiles,
    updateApk,
    ...props
}) {
    return (
        <ApkUpdate
            {...props}
            canAccess={canAccessFirmware}
            getVersion={getApkVersion}
            loadFiles={loadApkFiles}
            updateVersion={updateApk}
        />
    );
}
